// extracted by mini-css-extract-plugin
export default {"mapBlock":"map_block_mapBlock__zaQ+2","mapAddressWrap":"map_block_mapAddressWrap__RCLVt","mapAddress":"map_block_mapAddress__V5Y7-","mapContainer":"map_block_mapContainer__byCft"};